import { render, staticRenderFns } from "./order.vue?vue&type=template&id=3efa02ea&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=3efa02ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efa02ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efa02ea')) {
      api.createRecord('3efa02ea', component.options)
    } else {
      api.reload('3efa02ea', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=3efa02ea&scoped=true&", function () {
      api.rerender('3efa02ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/order.vue"
export default component.exports